// extracted by mini-css-extract-plugin
export default {"containerTerms":"terms_containerTerms__8Urn-","topics":"terms_topics__AUeKD","policies":"terms_policies__M1tE1","ContainerContactTerms":"terms_ContainerContactTerms__TSYFO"};